module.exports = __webpack_public_path__ + "img/3x.c8b9172.jpg";